import { endOfDay, startOfDay } from 'date-fns';

import { timezoneToUTCString } from 'utils/date';

export const toMidnight = (date, timezone) => timezoneToUTCString(startOfDay(date), timezone);

export const toMidnightEndOfDay = (date, timezone) => timezoneToUTCString(endOfDay(date), timezone);

export const toRange = (from, to) => {
  if (!from || !to) {
    return null;
  }

  return [from, to];
};
